(function () {
  if (customElements.get('ce-product-recommendations') !== undefined) {
    return;
  }

  class ProductRecommendations extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        section: `#shopify-section-${this.getAttribute('section-id')}`,
        this: 'ce-product-recommendations',
        toaster: 'ce-toaster',
      };

      this.resource = this.getAttribute('resource');
      this.hasLoaded = false;

      this.intersectionObserver = null;
    }

    parsedCallback() {
      this.elements = {
        section: document.querySelector(this.selectors.section),
        toaster: document.querySelector(this.selectors.toaster),
      };

      const callback = (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            if (!this.hasLoaded) {
              this._fetchSection();
              this.intersectionObserver.unobserve(this);
            }
          }
        }
      };

      const options = {
        rootMargin: '0px 0px 1440px 0px',
      };

      this.intersectionObserver = new IntersectionObserver(callback, options);
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.intersectionObserver.disconnect();
    }

    async _fetchSection() {
      try {
        const response = await fetch(this.resource);

        if (!response.ok) {
          throw Error;
        }

        const responseText = await response.text();

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const innerHTML = html.querySelector(this.selectors.this).innerHTML;

        if (innerHTML === '') {
          this.elements.section.remove();
        } else {
          this.innerHTML = innerHTML;
        }

        this.hasLoaded = true;
      } catch (error) {
        this.elements.toaster.makeToast('danger', Themu.t.sections.product_recommendations.error_message);
      }
    }
  }

  customElements.define('ce-product-recommendations', ProductRecommendations);
})();
